import React, { useState, useEffect, useContext } from "react";
import LangContext from "../utils/LangContext";
import { langAPI } from "../api/langAPI";
import ImageSlider from "../utils/ImageSlider";

export default function Streifzug() {
  const [state, setState] = useState([]);
  const { lang } = useContext(LangContext);

  useEffect(() => {
    langAPI(lang).then(setState);
  }, [lang]);

  return state.map((item, idx) => <RenderStreifzug key={idx} data={item} />);
}

const SliderData = [
  {
    image: require("../images/project_1/Streifzug23page-a.png"),
  },
  {
    image: require("../images/project_1/Streifzug23page-b.png"),
  },
  {
    image: require("../images/project_1/Streifzug23page-c.png"),
  },
];

const RenderStreifzug = ({ data }) => {
  return (
    <>
      <div className="mt-36">
        <h1 className="md:px-40 px-4">
          Umfrage und Gewinnspiel für den Kurzfilmstreifzug 2023
        </h1>
        <p className="md:px-40 px-4">{data.body.streif}</p>

        <ImageSlider slides={SliderData} />
      </div>
    </>
  );
};
